import React from 'react';

const ProductFilter = ({ filters, setFilters }) => {
  const handleInputChange = (e) => {
    setFilters(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="mb-3 p-2 rounded shadow-sm" style={{ background: "#f8f9fa" }}>
      <form className="d-flex flex-wrap gap-2 align-items-center justify-content-center">
        {/* Búsqueda por nombre */}
        <div className="d-flex align-items-center" style={{ minWidth: 200 }}>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Buscar por nombre"
            name="search"
            value={filters.search}
            onChange={handleInputChange}
            style={{ flex: 1 }}
          />
          <i className="bi bi-search ms-2" style={{ color: '#888', fontSize: '1.1rem' }}></i>
        </div>
        {/* Ordenar por */}
        <div className="d-flex align-items-center" style={{ minWidth: 180 }}>
          <select
            className="form-select form-select-sm"
            name="sort"
            value={filters.sort || ""}
            onChange={handleInputChange}
            style={{ flex: 1 }}
          >
            <option value="">Ordenar por</option>
            <option value="price-asc">Precio: Menor a mayor</option>
            <option value="price-desc">Precio: Mayor a menor</option>
            <option value="name-asc">Nombre: A-Z</option>
            <option value="name-desc">Nombre: Z-A</option>
          </select>
          <i className="bi bi-funnel ms-2" style={{ color: '#888', fontSize: '1.1rem' }}></i>
        </div>
      </form>
    </div>
  );
};

export default ProductFilter;
